(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurore-cart-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.auroreRecoveryInstalled) return;
  window.auroreRecoveryInstalled = true;
  const config = document.getElementById('aurore-recovery-config');
  if (!config) return;
  const root = config.dataset.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const hashPrefix = '#aurore-recover=';
  let restoring = location.hash.startsWith(hashPrefix);
  let timer;
  let busy = false;
  let lastSignature = '';
  let identifiedEmail = '';
  const publicSiteId = 'Xj9SzM';
  const encode = value => btoa(Array.from(new TextEncoder().encode(JSON.stringify(value)), n => String.fromCharCode(n)).join('')).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const decode = value => JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(Uint8Array.from(atob(value.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0))));
  const cleanItems = items => {
    if (!Array.isArray(items) || !items.length || items.length > 20) throw new Error('items');
    return items.map(item => {
      const id = Number(item.variant_id || item.id);
      const quantity = Number(item.quantity);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity < 1 || quantity > 100 || item.selling_plan_allocation) throw new Error('variant');
      const properties = Object.create(null);
      const pairs = Object.entries(item.properties || {});
      if (pairs.length > 50) throw new Error('properties');
      for (const [key, value] of pairs) {
        if (['__proto__', 'prototype', 'constructor'].includes(key) || key.length > 255 || !['string', 'number'].includes(typeof value) || String(value).length > 4000) throw new Error('property');
        properties[key] = String(value);
      }
      return { id, quantity, properties };
    });
  };
  const signature = items => JSON.stringify(items.map(item => ({ id: item.id, quantity: item.quantity, properties: Object.entries(item.properties).sort(([a], [b]) => a.localeCompare(b)) })).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
  const recentKey = async key => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(key));
    return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
  };
  const request = async (path, data) => {
    const response = await nativeFetch(root + path, data === undefined ? { credentials: 'same-origin', cache: 'no-store' } : { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const consented = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed());
  };
  const track = async () => {
    if (restoring || busy) return;
    if (!consented()) { config.dataset.trackingStatus = 'consent-required'; return; }
    if (identifiedEmail && !document.querySelector('input[name="email_concent"]')?.checked) { config.dataset.trackingStatus = 'email-opt-out'; return; }
    if (!identifiedEmail && !window.klaviyo) { config.dataset.trackingStatus = 'klaviyo-loading'; return; }
    busy = true;
    try {
      if (!identifiedEmail && !(await window.klaviyo.isIdentified())) { config.dataset.trackingStatus = 'anonymous'; return; }
      const cart = await request('cart.js');
      if (!cart.items.length) return;
      const items = cleanItems(cart.items);
      const key = signature(items) + '|' + identifiedEmail;
      if (key === lastSignature) return;
      try { if (sessionStorage.getItem('aurore-recovery-tracked') === key) return; } catch (error) {}
      let recentHash = '';
      try {
        recentHash = await recentKey(key);
        const recent = JSON.parse(localStorage.getItem('aurore-recovery-recent') || '{}');
        if (recent.hash === recentHash && Date.now() - recent.at < 30 * 60 * 1000) return;
      } catch (error) {}
      const payload = encode({ v: 1, currency: cart.currency, items });
      if (payload.length > 18000) return;
      const recovery = new URL(root + 'cart', location.origin);
      recovery.hash = 'aurore-recover=' + payload;
      const properties = {
        RecoveryVersion: 1, CartRecoveryURL: recovery.href, Currency: cart.currency,
        $value: cart.total_price / 100, ItemCount: cart.item_count,
        Items: cart.items.map(item => ({ ProductID: item.product_id, VariantID: item.variant_id, ProductName: item.product_title, VariantName: item.variant_title || '', Quantity: item.quantity, Price: item.final_price / 100, ImageURL: item.featured_image ? item.featured_image.url : item.image, ProductURL: new URL(item.url, location.origin).href })),
        $event_id: 'aurore-cart-' + crypto.randomUUID()
      };
      let accepted;
      let responseStatus = '';
      if (identifiedEmail) {
        const response = await nativeFetch('https://a.klaviyo.com/client/events?company_id=' + publicSiteId, {
          method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties, value: cart.total_price / 100, value_currency: cart.currency,
            unique_id: properties.$event_id,
            metric: { data: { type: 'metric', attributes: { name: 'Aurore Personalized Cart' } } },
            profile: { data: { type: 'profile', attributes: { email: identifiedEmail } } }
          } } })
        });
        responseStatus = String(response.status);
        accepted = response.status === 202;
      } else {
        accepted = await window.klaviyo.track('Aurore Personalized Cart', properties);
      }
      if (accepted !== false) {
        lastSignature = key;
        config.dataset.trackingStatus = 'tracked';
        try { sessionStorage.setItem('aurore-recovery-tracked', key); } catch (error) {}
        try { if (recentHash) localStorage.setItem('aurore-recovery-recent', JSON.stringify({ hash: recentHash, at: Date.now() })); } catch (error) {}
      } else { config.dataset.trackingStatus = 'rejected'; config.dataset.trackingError = identifiedEmail ? responseStatus : 'track-rejected'; }
    } catch (error) { config.dataset.trackingStatus = 'unavailable'; config.dataset.trackingError = String(error && error.message || error).slice(0, 160); } finally { busy = false; }
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(track, 1200); };
  // Middleware collects the email in its first checkout step. Identify only
  // after the customer finishes that field, and only when onsite processing
  // is allowed. The Klaviyo flow independently checks marketing subscription.
  const identifyMiddlewareEmail = event => {
    const field = event.target;
    if (!field || !['mw-email', 'email_concent'].includes(field.id || field.name) || !consented()) return;
    if (!document.querySelector('input[name="email_concent"]')?.checked) return;
    const email = String(document.querySelector('#mw-email')?.value || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email === identifiedEmail) return;
    identifiedEmail = email;
    config.dataset.trackingStatus = 'identified';
    schedule();
  };
  document.addEventListener('change', identifyMiddlewareEmail, true);
  document.addEventListener('focusout', identifyMiddlewareEmail, true);
  const isCartWrite = value => {
    try {
      const url = new URL(value instanceof Request ? value.url : String(value), location.href);
      return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    } catch (error) { return false; }
  };
  window.fetch = function (...args) {
    const promise = nativeFetch(...args);
    if (isCartWrite(args[0])) promise.then(response => { if (response.ok) schedule(); }, () => {});
    return promise;
  };
  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  const cartRequests = new WeakSet();
  XMLHttpRequest.prototype.open = function (...args) {
    if (isCartWrite(args[1])) cartRequests.add(this); else cartRequests.delete(this);
    return nativeOpen.apply(this, args);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (cartRequests.has(this)) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) schedule(); }, { once: true });
    return nativeSend.apply(this, args);
  };
  ['visitorConsentCollected', 'cart:updated', 'cart:change', 'klaviyo:identify'].forEach(name => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], schedule);
  [1500, 5000, 15000, 30000].forEach(delay => setTimeout(track, delay));
  if (!restoring) return;
  const panel = document.createElement('section');
  panel.className = 'aurore-recovery';
  panel.setAttribute('aria-label', config.dataset.title);
  const heading = document.createElement('h2');
  heading.textContent = config.dataset.title;
  const description = document.createElement('p');
  description.textContent = config.dataset.body;
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = config.dataset.button;
  panel.append(heading, description, button, status);
  (document.querySelector('main') || document.body).prepend(panel);
  let payload;
  let items;
  try {
    const encoded = location.hash.slice(hashPrefix.length);
    if (encoded.length > 18000 || !/^[A-Za-z0-9_-]+$/.test(encoded)) throw new Error('payload');
    payload = decode(encoded);
    if (payload.v !== 1 || typeof payload.currency !== 'string') throw new Error('version');
    items = cleanItems(payload.items);
  } catch (error) {
    button.hidden = true;
    status.textContent = config.dataset.invalid;
    return;
  }
  const restore = async (auto = false) => {
    if (button.disabled) return;
    button.disabled = true;
    status.textContent = config.dataset.working;
    let backup;
    let mutated = false;
    try {
      backup = await request('cart.js');
      if (backup.currency !== payload.currency) throw new Error('currency');
      // The cart could change between the initial empty check and this read.
      // Do not replace new items without the customer's explicit confirmation.
      if (auto && backup.items.length) {
        status.textContent = '';
        button.disabled = false;
        return;
      }
      if (backup.items.length && signature(cleanItems(backup.items)) === signature(items)) {
        status.textContent = config.dataset.ready;
        button.hidden = true;
        return;
      }
      if (backup.items.length) cleanItems(backup.items);
      mutated = true;
      await request('cart/clear.js', {});
      await request('cart/add.js', { items });
      const restored = await request('cart.js');
      if (signature(cleanItems(restored.items)) !== signature(items)) throw new Error('verification');
      try { sessionStorage.setItem('aurore-recovery-tracked', signature(items)); } catch (error) {}
      const next = new URL(location.href);
      next.hash = '';
      location.replace(next.href);
    } catch (error) {
      let rolledBack = true;
      if (mutated && backup) {
        try {
          await request('cart/clear.js', {});
          if (backup.items.length) await request('cart/add.js', { items: cleanItems(backup.items) });
        } catch (rollbackError) { rolledBack = false; }
      }
      status.textContent = rolledBack ? config.dataset.error : config.dataset.rollbackError;
      button.disabled = false;
    }
  };
  button.addEventListener('click', () => restore(false));
  // Opening a recovery link is the customer's explicit request. When their
  // current cart is empty, restore it immediately; replacing a nonempty cart
  // still requires the visible confirmation button.
  request('cart.js').then(cart => {
    if (!cart.items.length) restore(true);
  }).catch(() => {});
})();
  } catch(e) { console.error(e); }
})();

})();
